'use client';

import React from 'react';
import { CanLogoIcon } from '../../../../../public/assets/icons';
import { Box, Text } from '@chakra-ui/react';
import { PaymentProps } from './types/template.types';
import CardPreferenceForm from '../forms/card-preference/CardPreferenceForm';
import useProductPrice from '@/hooks/product/useProductPrice';

const CardPreference = ({ next }: PaymentProps) => {
   const { price } = useProductPrice();
   return (
      <>
         <Box minH="72px">
            <CanLogoIcon />
         </Box>
         <Text
            as="h2"
            color="white"
            fontSize={{ base: '4xl', sm: '5xl', md: '6xl' }}
            fontWeight="bold"
            textAlign="center"
         >
            PAY NOW
         </Text>
         <Text color="white" textStyle="md" textAlign="center" mt="-10px" mb="2">
            Click the button below to complete your £{price} payment
         </Text>
         <CardPreferenceForm next={next} />
      </>
   );
};

export default CardPreference;
